import { render, staticRenderFns } from "./ProcessSimulate.vue?vue&type=template&id=bfedba6a&scoped=true"
import script from "./ProcessSimulate.vue?vue&type=script&lang=js"
export * from "./ProcessSimulate.vue?vue&type=script&lang=js"
import style1 from "./ProcessSimulate.vue?vue&type=style&index=1&id=bfedba6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfedba6a",
  null
  
)

export default component.exports